import React, { Component } from "react";
import * as DKFDS from "dkfds";

export class FstyrDatePicker extends Component {
  constructor(props) {
    super(props);

    /*
        PROPS:

        value
        onChange()
        direction
        label
        buttonClicked
        setDateComplete()
        onValidatingButtonPressed()

        */

    this.state = {};
  }

  componentDidMount() {
    DKFDS.init();
  }

  componentDidUpdate() {}

  validate(date) {
    if (!(this.getDatePart(date, 2) > 31 || this.getDatePart(date, 2) < 1 || this.getDatePart(date, 2) === "") && !(this.getDatePart(date, 1) > 12 || this.getDatePart(date, 1) < 1 || this.getDatePart(date, 1) === "") && !(this.getDatePart(date, 0) > 3000 || this.getDatePart(date, 0) < 1900 || this.getDatePart(date, 0) === "")) {
      this.props.setDateComplete(true);
    } else {
      this.props.setDateComplete(false);
    }
  }

  setDay(value) {
    var date = this.getDatePart(this.props.value, 0) + "-" + this.getDatePart(this.props.value, 1) + "-" + value;
    this.props.onChange(date);
    this.validate(date);
  }

  setMonth(value) {
    var date = this.getDatePart(this.props.value, 0) + "-" + value + "-" + this.getDatePart(this.props.value, 2);
    this.props.onChange(date);
    this.validate(date);
  }

  setYear(value) {
    var date = value + "-" + this.getDatePart(this.props.value, 1) + "-" + this.getDatePart(this.props.value, 2);
    this.props.onChange(date);
    this.validate(date);
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      if (!this.dayError(true) || !this.monthError(true) || !this.yearError(true)) {
        this.props.onEnterPressed();
      }
    }
  }

  getDatePart(date, part) {
    let stringArray = date.split("-");
    return stringArray[part];
  }

  dayError(emptyFieldIsError) {
    if (emptyFieldIsError) {
      return this.getDatePart(this.props.value, 2) > 31 || this.getDatePart(this.props.value, 2) < 1 || this.getDatePart(this.props.value, 2) === "";
    } else {
      return this.getDatePart(this.props.value, 2) === "" ? false : this.getDatePart(this.props.value, 2) > 31 || this.getDatePart(this.props.value, 2) < 1;
    }
  }

  monthError(emptyFieldIsError) {
    if (emptyFieldIsError) {
      return this.getDatePart(this.props.value, 1) > 12 || this.getDatePart(this.props.value, 1) < 1 || this.getDatePart(this.props.value, 1) === "";
    } else {
      return this.getDatePart(this.props.value, 1) === "" ? false : this.getDatePart(this.props.value, 1) > 12 || this.getDatePart(this.props.value, 1) < 1;
    }
  }

  yearError(emptyFieldIsError) {
    if (emptyFieldIsError) {
      return this.getDatePart(this.props.value, 0) > 3000 || this.getDatePart(this.props.value, 0) < 1900 || this.getDatePart(this.props.value, 0) === "";
    } else {
      return this.getDatePart(this.props.value, 0) === "" ? false : this.getDatePart(this.props.value, 0) > 3000 || this.getDatePart(this.props.value, 0) < 1900;
    }
  }

  render() {
    return (
      <div className={this.props.buttonClicked && (this.dayError(true) || this.monthError(true) || this.yearError(true)) ? " form-error" : ""}>
        <fieldset aria-describedby="example-date-field-hint ">
          <div className="datepicker-align-row datepicker-input">
            <label className="form-label">{this.props.label}</label>
            <div className="date-group js-calendar-group">
              <div className="form-group form-group-day">
                <input className="form-input" value={this.getDatePart(this.props.value, 2)} id="date-day" type="tel" data-min="2" data-max="31" maxLength="2" pattern="^[0-9]{0,2}$" data-input-regex="^[0-9]{0,2}$" title="Indskriv dag på måneden som tal" placeholder="dd" aria-describedby="example-date-field-hint" onChange={(e) => this.setDay(e.target.value)} onKeyPress={(e) => this.handleKeyPress(e)} style={{ textAlign: "center", minWidth: "6rem" }} />
              </div>
              <div className="form-group form-group-month">
                <input className="form-input" value={this.getDatePart(this.props.value, 1)} id="date-month" type="tel" data-min="1" data-max="12" maxLength="2" pattern="^[0-9]{0,2}$" data-input-regex="^[0-9]{0,2}$" title="Indskriv månedens nummer" placeholder="mm" aria-describedby="example-date-field-hint" onChange={(e) => this.setMonth(e.target.value)} onKeyPress={(e) => this.handleKeyPress(e)} style={{ textAlign: "center", minWidth: "6rem" }} />
              </div>
              <div className="form-group form-group-year">
                <input className="form-input" value={this.getDatePart(this.props.value, 0)} id="date-year" type="tel" data-min="1900" data-max="3000" maxLength="4" pattern="^[0-9]{0,4}$" data-input-regex="^[0-9]{0,4}$" title="Indskriv årstal" placeholder="yyyy" aria-describedby="example-date-field-hint" onChange={(e) => this.setYear(e.target.value)} onKeyPress={(e) => this.handleKeyPress(e)} style={{ textAlign: "center", minWidth: "6rem" }} />
              </div>
            </div>
          </div>
          <div className="datepicker-align-errors">
            {((this.props.buttonClicked && this.dayError(true)) || this.dayError(false)) && (
              <span className="form-error-message" id="example-date-field-error2">
                <span className="sr-only">Fejl:</span>Indtast en gyldig dato.
              </span>
            )}
            {((this.props.buttonClicked && this.monthError(true)) || this.monthError(false)) && (
              <span className="form-error-message" id="example-date-field-error2">
                <span className="sr-only">Fejl:</span>Indtast en gyldig måned.
              </span>
            )}
            {((this.props.buttonClicked && this.yearError(true)) || this.yearError(false)) && (
              <span className="form-error-message" id="example-date-field-error2">
                <span className="sr-only">Fejl:</span>Indtast et gyldigt årstal.
              </span>
            )}
          </div>
        </fieldset>
      </div>
    );
  }
}
